import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { IconCouple } from '@op/opds.opux-icons/misc';
import { IconSustainability } from '@op/opds.opux-icons/finance';
import { IconLegal } from '@op/opds.opux-icons/insurance';
import styles from './InfoTextBox.module.scss';

const InfoTextBox1 = (): ReactElement => {
  return (
    <div className={styles.container}>
      <p className={styles.title} id="course-8-infobox-1-title">
        <Message id="course8.part1.infobox1.title" />
      </p>
      <dl aria-labelledby="course-8-infobox-1-title" className={styles.definitionList}>
        <dt>
          <IconSustainability size="large" className={styles.icon} />
          <Message id="course8.part1.infobox1.term1" />
        </dt>
        <dd>
          <Message id="course8.part1.infobox1.definition1" />
        </dd>
        <dt>
          <IconCouple size="large" className={styles.icon} />
          <Message id="course8.part1.infobox1.term2" />
        </dt>
        <dd>
          <Message id="course8.part1.infobox1.definition2" />
        </dd>
        <dt>
          <IconLegal size="large" className={styles.icon} />
          <Message id="course8.part1.infobox1.term3" />
        </dt>
        <dd>
          <Message id="course8.part1.infobox1.definition3" />
        </dd>
      </dl>
    </div>
  );
};

export default InfoTextBox1;
